module.exports = __webpack_public_path__ + "img/flavour-chooser-instruction-arrow.f7344f5c.svg";